var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.6C4.46538 1.6 1.6 4.46538 1.6 8C1.6 11.5346 4.46538 14.4 8 14.4C11.5346 14.4 14.4 11.5346 14.4 8C14.4 4.46538 11.5346 1.6 8 1.6ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#2B343E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88091 5.19309C6.66264 5.4184 6.55145 5.71594 6.49932 5.97875C6.41336 6.41214 5.99235 6.69378 5.55896 6.60782C5.12558 6.52186 4.84393 6.10084 4.92989 5.66746C5.01542 5.23627 5.22062 4.60741 5.73172 4.07982C6.26427 3.53009 7.05157 3.17031 8.1369 3.17031C8.84366 3.17031 9.58741 3.40863 10.1608 3.9516C10.7456 4.50545 11.0855 5.31214 11.0855 6.31284C11.0855 7.30825 10.6846 8.0358 10.101 8.51524C9.62166 8.90905 9.05943 9.10424 8.59172 9.19777C8.58069 9.62999 8.22686 9.97698 7.79198 9.97698C7.35016 9.97698 6.99198 9.6188 6.99198 9.17698V8.95925C6.99198 8.2315 7.56705 7.73847 8.15123 7.65097C8.492 7.59993 8.83901 7.48132 9.0853 7.27897C9.29926 7.10318 9.48549 6.82909 9.48549 6.31284C9.48549 5.68923 9.28372 5.32465 9.06057 5.11332C8.82592 4.89111 8.49538 4.77031 8.1369 4.77031C7.43274 4.77031 7.07772 4.98993 6.88091 5.19309Z",
    fill: "#2B343E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98281 11.6326C6.98281 11.1908 7.34098 10.8326 7.78281 10.8326H7.79241C8.23424 10.8326 8.59241 11.1908 8.59241 11.6326C8.59241 12.0744 8.23424 12.4326 7.79241 12.4326H7.78281C7.34098 12.4326 6.98281 12.0744 6.98281 11.6326Z",
    fill: "#2B343E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.7566e12941db16c699c0d6be4ddf11de.svg";
export { ForwardRef as ReactComponent };